/**
 * MAS Indirect template formulas (implementations).
 * Indirect-only COGS formulas; shared formulas remain in shared/formulas.
 */

export const calculateGSMSCostIndirect = (
  gsmsIffFee: number,
  gsmsNetCostFromMfg: number
): number => {
  return gsmsIffFee + gsmsNetCostFromMfg;
};

/** Indirect: GSMS Marketing Fee = Suggested Bid Price - GSMS Net Cost From Mfg */
export const calculateGSMSMarketingFee = (
  suggestedBidPrice: number,
  gsmsNetCostFromMfg: number
): number => {
  return suggestedBidPrice - gsmsNetCostFromMfg;
};
